(function () {
  'use strict';

  angular
    .module('app.autocomplete', [])

    .directive('autoCompleteSearch', function () {
      return {
        restrict: 'E',
        scope: true,
        bindToController: {
          textAdvices: '@'
        },
        controllerAs: 'searchCtrl',
        /* @ngInject */
        controller: ["$rootScope", "$element", "searchFinderService", "$location", "RoutesService", function ($rootScope, $element, searchFinderService, $location, RoutesService) {

          // $element, $http, $location, $timeout, $sce, RoutesService

          var ctrl = this;

          ctrl.goSearch = function (str) {
            if (str) {
              var url = RoutesService.get().Search.route + '/' + encodeURI(str.split(' ').join('+'));
              $location.path(url);

              $rootScope.$broadcast('searchClose');
            }
          };

          ctrl.inputChangeHandler = function () {
            $rootScope.$broadcast('searchUpdate');
          };

          ctrl.$onInit = function () {
            searchFinderService.setCtrl(ctrl);
          };

          ctrl.submitSearch = function () {
            // console.log('submit submit' + ctrl.searchStr);

            /* if (ctrl.searchStr && ctrl.searchStr !== '') {
              var url = RoutesService.get().Search.route + '/' + encodeURI(ctrl.searchStr.split(' ').join('+'));
              $location.path(url);
              $rootScope.$broadcast('searchClose');
            }*/

            ctrl.goSearch(ctrl.searchStr);

            event.preventDefault();
            $(event.target).find('.search-query').blur();
          };
        }]
      };
    });

})();
